unit View.Parceiros.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewParceirosList = class(TForm)
    btNew: TButton;
    ParceirosDataset: TXDataWebDataSet;
    ParceirosDatasetid: TIntegerField;
    ParceirosDatasetnome: TStringField;
    ParceirosDatasetendereco: TStringField;
    ParceirosDatasetcomplemento: TStringField;
    ParceirosDatasetbairro: TStringField;
    ParceirosDatasetcep: TStringField;
    ParceirosDatasettelefone1: TStringField;
    ParceirosDatasettelefone2: TStringField;
    ParceirosDatasetcelular: TStringField;
    ParceirosDatasetemail: TStringField;
    ParceirosDatasetsite: TStringField;
    ParceirosDatasetresponsavel: TStringField;
    ParceirosDatasetcidade_id: TIntegerField;
    ParceirosDatasetexcluido: TBooleanField;
    ParceirosDatasetinclusao: TDateTimeField;
    ParceirosDatasetalteracao: TDateTimeField;
    ParceirosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewParceirosList: TFViewParceirosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewParceirosList }

procedure TFViewParceirosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewParceirosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewParceirosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewParceirosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewParceirosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewParceirosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewParceirosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ParceirosDataset.Connection.Model.DefaultSchema.FindEntityType(ParceirosDataset.EntitySetName),
      ParceirosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewParceirosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('parceiros', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    ParceirosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewParceirosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.parceiros.list.pagination.info');
  btNew := TButton.Create('view.parceiros.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.parceiros.list.table');
  cbPageSize := TComboBox.Create('view.parceiros.list.cbPageSize');
  edSearch := TEdit.Create('view.parceiros.list.search');
  lcPaginator := TListControl.Create('view.parceiros.list.pagination');
  ParceirosDataset := TXDataWebDataSet.Create(Self);
  ParceirosDatasetid := TIntegerField.Create(Self);
  ParceirosDatasetnome := TStringField.Create(Self);
  ParceirosDatasetendereco := TStringField.Create(Self);
  ParceirosDatasetcomplemento := TStringField.Create(Self);
  ParceirosDatasetbairro := TStringField.Create(Self);
  ParceirosDatasetcep := TStringField.Create(Self);
  ParceirosDatasettelefone1 := TStringField.Create(Self);
  ParceirosDatasettelefone2 := TStringField.Create(Self);
  ParceirosDatasetcelular := TStringField.Create(Self);
  ParceirosDatasetemail := TStringField.Create(Self);
  ParceirosDatasetsite := TStringField.Create(Self);
  ParceirosDatasetresponsavel := TStringField.Create(Self);
  ParceirosDatasetcidade_id := TIntegerField.Create(Self);
  ParceirosDatasetexcluido := TBooleanField.Create(Self);
  ParceirosDatasetinclusao := TDateTimeField.Create(Self);
  ParceirosDatasetalteracao := TDateTimeField.Create(Self);
  ParceirosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ParceirosDataset.BeforeLoadDFMValues;
  ParceirosDatasetid.BeforeLoadDFMValues;
  ParceirosDatasetnome.BeforeLoadDFMValues;
  ParceirosDatasetendereco.BeforeLoadDFMValues;
  ParceirosDatasetcomplemento.BeforeLoadDFMValues;
  ParceirosDatasetbairro.BeforeLoadDFMValues;
  ParceirosDatasetcep.BeforeLoadDFMValues;
  ParceirosDatasettelefone1.BeforeLoadDFMValues;
  ParceirosDatasettelefone2.BeforeLoadDFMValues;
  ParceirosDatasetcelular.BeforeLoadDFMValues;
  ParceirosDatasetemail.BeforeLoadDFMValues;
  ParceirosDatasetsite.BeforeLoadDFMValues;
  ParceirosDatasetresponsavel.BeforeLoadDFMValues;
  ParceirosDatasetcidade_id.BeforeLoadDFMValues;
  ParceirosDatasetexcluido.BeforeLoadDFMValues;
  ParceirosDatasetinclusao.BeforeLoadDFMValues;
  ParceirosDatasetalteracao.BeforeLoadDFMValues;
  ParceirosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewParceirosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'endereco';
      Title := 'endereco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'complemento';
      Title := 'complemento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'bairro';
      Title := 'bairro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cep';
      Title := 'cep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefone1';
      Title := 'telefone1';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefone2';
      Title := 'telefone2';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'celular';
      Title := 'celular';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'email';
      Title := 'email';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'site';
      Title := 'site';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'responsavel';
      Title := 'responsavel';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cidade_id';
      Title := 'cidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    ParceirosDataset.SetParentComponent(Self);
    ParceirosDataset.Name := 'ParceirosDataset';
    ParceirosDataset.EntitySetName := 'Parceiros';
    ParceirosDataset.Connection := DMConnection.ApiConnection;
    ParceirosDataset.Left := 72;
    ParceirosDataset.Top := 144;
    ParceirosDatasetid.SetParentComponent(ParceirosDataset);
    ParceirosDatasetid.Name := 'ParceirosDatasetid';
    ParceirosDatasetid.FieldName := 'id';
    ParceirosDatasetid.Required := True;
    ParceirosDatasetnome.SetParentComponent(ParceirosDataset);
    ParceirosDatasetnome.Name := 'ParceirosDatasetnome';
    ParceirosDatasetnome.FieldName := 'nome';
    ParceirosDatasetnome.Size := 255;
    ParceirosDatasetendereco.SetParentComponent(ParceirosDataset);
    ParceirosDatasetendereco.Name := 'ParceirosDatasetendereco';
    ParceirosDatasetendereco.FieldName := 'endereco';
    ParceirosDatasetendereco.Size := 255;
    ParceirosDatasetcomplemento.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcomplemento.Name := 'ParceirosDatasetcomplemento';
    ParceirosDatasetcomplemento.FieldName := 'complemento';
    ParceirosDatasetcomplemento.Size := 255;
    ParceirosDatasetbairro.SetParentComponent(ParceirosDataset);
    ParceirosDatasetbairro.Name := 'ParceirosDatasetbairro';
    ParceirosDatasetbairro.FieldName := 'bairro';
    ParceirosDatasetbairro.Size := 255;
    ParceirosDatasetcep.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcep.Name := 'ParceirosDatasetcep';
    ParceirosDatasetcep.FieldName := 'cep';
    ParceirosDatasetcep.Size := 255;
    ParceirosDatasettelefone1.SetParentComponent(ParceirosDataset);
    ParceirosDatasettelefone1.Name := 'ParceirosDatasettelefone1';
    ParceirosDatasettelefone1.FieldName := 'telefone1';
    ParceirosDatasettelefone1.Size := 255;
    ParceirosDatasettelefone2.SetParentComponent(ParceirosDataset);
    ParceirosDatasettelefone2.Name := 'ParceirosDatasettelefone2';
    ParceirosDatasettelefone2.FieldName := 'telefone2';
    ParceirosDatasettelefone2.Size := 255;
    ParceirosDatasetcelular.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcelular.Name := 'ParceirosDatasetcelular';
    ParceirosDatasetcelular.FieldName := 'celular';
    ParceirosDatasetcelular.Size := 255;
    ParceirosDatasetemail.SetParentComponent(ParceirosDataset);
    ParceirosDatasetemail.Name := 'ParceirosDatasetemail';
    ParceirosDatasetemail.FieldName := 'email';
    ParceirosDatasetemail.Size := 255;
    ParceirosDatasetsite.SetParentComponent(ParceirosDataset);
    ParceirosDatasetsite.Name := 'ParceirosDatasetsite';
    ParceirosDatasetsite.FieldName := 'site';
    ParceirosDatasetsite.Size := 255;
    ParceirosDatasetresponsavel.SetParentComponent(ParceirosDataset);
    ParceirosDatasetresponsavel.Name := 'ParceirosDatasetresponsavel';
    ParceirosDatasetresponsavel.FieldName := 'responsavel';
    ParceirosDatasetresponsavel.Size := 255;
    ParceirosDatasetcidade_id.SetParentComponent(ParceirosDataset);
    ParceirosDatasetcidade_id.Name := 'ParceirosDatasetcidade_id';
    ParceirosDatasetcidade_id.FieldName := 'cidade_id';
    ParceirosDatasetexcluido.SetParentComponent(ParceirosDataset);
    ParceirosDatasetexcluido.Name := 'ParceirosDatasetexcluido';
    ParceirosDatasetexcluido.FieldName := 'excluido';
    ParceirosDatasetinclusao.SetParentComponent(ParceirosDataset);
    ParceirosDatasetinclusao.Name := 'ParceirosDatasetinclusao';
    ParceirosDatasetinclusao.FieldName := 'inclusao';
    ParceirosDatasetalteracao.SetParentComponent(ParceirosDataset);
    ParceirosDatasetalteracao.Name := 'ParceirosDatasetalteracao';
    ParceirosDatasetalteracao.FieldName := 'alteracao';
    ParceirosDatasetexclusao.SetParentComponent(ParceirosDataset);
    ParceirosDatasetexclusao.Name := 'ParceirosDatasetexclusao';
    ParceirosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ParceirosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ParceirosDataset.AfterLoadDFMValues;
    ParceirosDatasetid.AfterLoadDFMValues;
    ParceirosDatasetnome.AfterLoadDFMValues;
    ParceirosDatasetendereco.AfterLoadDFMValues;
    ParceirosDatasetcomplemento.AfterLoadDFMValues;
    ParceirosDatasetbairro.AfterLoadDFMValues;
    ParceirosDatasetcep.AfterLoadDFMValues;
    ParceirosDatasettelefone1.AfterLoadDFMValues;
    ParceirosDatasettelefone2.AfterLoadDFMValues;
    ParceirosDatasetcelular.AfterLoadDFMValues;
    ParceirosDatasetemail.AfterLoadDFMValues;
    ParceirosDatasetsite.AfterLoadDFMValues;
    ParceirosDatasetresponsavel.AfterLoadDFMValues;
    ParceirosDatasetcidade_id.AfterLoadDFMValues;
    ParceirosDatasetexcluido.AfterLoadDFMValues;
    ParceirosDatasetinclusao.AfterLoadDFMValues;
    ParceirosDatasetalteracao.AfterLoadDFMValues;
    ParceirosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
